import { Button, Flex, Modal } from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { CustomTitle } from "../../../../../common/customTitle";
import { colors } from "../../../../../../constants/colors";
import { useDispatch } from "react-redux";
import { runManualPayrollAction } from "../../../../../../redux/services/payroll/payrollServices";

const ConfirmManualPayroll = ({ open, onClose, data, handleGetTableData }) => {
  /* translation dependencies */
  const { t } = useTranslation();
  /* translation dependencies */

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleRunManualPayroll = () => {
    if (
      data?._id &&
      data?._id !== "" &&
      data?._id !== null &&
      data?._id !== undefined
    ) {
      const selectedPayrollId = data?._id;
      const dataToBeSent = { selectedPayrollId };
      dispatch(runManualPayrollAction(dataToBeSent, setLoading)).then((res) => {
        onClose();
        handleGetTableData();
      });
    }
  };

  return (
    <Modal open={open} onCancel={onClose} footer={false}>
      <Flex
        vertical
        gap="2rem"
        align="center"
        justify="center"
        style={{ padding: "30px 0px" }}
      >
        <CustomTitle
          justifyContent="center"
          style={{ color: colors.primaryColor }}
        >
          {t(`confirmManuralPayroll`)}
        </CustomTitle>

        <Title level={2} style={{ margin: 0 }}>
          {t(`areYouSureManualPayroll`)}
        </Title>

        <Flex gap="0.8rem">
          <Button
            loading={loading}
            type="primary"
            onClick={() => handleRunManualPayroll()}
          >
            {t("confirmationPopup.buttonYesText")}
          </Button>

          <Button
            type="default"
            // className={styles.buttonStyle}

            onClick={() => onClose()}
          >
            {t("confirmationPopup.buttonNoText")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConfirmManualPayroll;
